import { Button, Modal } from 'antd';
import { ReactComponent as SvgClose } from 'utils/app/assets/icons/Close.svg';

import './styles.css';

export interface DeleteLayoutModalProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
    title: string;
    setIsModalVisible: (visible: boolean) => void;
    layoutName: string;
}

export const DeleteLayoutModal: React.FC<DeleteLayoutModalProps> = ({
    visible,
    onCancel,
    title,
    onOk,
    layoutName,
}) => {
    const handleOk = () => {};

    return (
        <Modal
            title={
                <div className="modal_header headline small">
                    <span className="modal-title">{title}</span>
                    {<SvgClose className="custom-close-icon" onClick={onCancel} />}
                </div>
            }
            className={'delete-layout-modal'}
            visible={visible}
            onOk={handleOk}
            destroyOnClose
            onCancel={onCancel}
            footer={[
                <Button
                    key="cancel"
                    className="button-base button-type-secondary button-size-medium"
                    onClick={onCancel}
                >
                    Нет
                </Button>,
                <Button
                    key="ok"
                    className="button-base button-type-primary button-size-medium"
                    onClick={onOk}
                >
                    Да
                </Button>,
            ]}
        >
            Удалить "{layoutName}"
        </Modal>
    );
};
